import {
  take,
  put,
  select,
  takeLatest,
  cancel,
  call,
} from 'redux-saga/effects';
import get from 'lodash/get';

import * as blockslotInsert from '../requests/blockslot-insert-req';
import * as blockslotUpdate from '../requests/blockslot-update-req';
import { SCHEDULE_VALIDATE_TYPES, scheduleValidateActions } from '../validate';
import { selectSchedulePopoverData } from '../selectors';
import { RECURSION_MODAL_TYPES } from '../../../components/ProviderCalendar/constants';
import {
  isLastDayOfRepeat,
  repeatScheduleAdapter,
} from '../../../utils/schedule/repeat-schedule-adapter';

function* insertOrUpdateBlockedSlot(payload) {
  // const selected = yield select(selectSchedulePopoverData);
  // const isRepeatable = get(selected, 'isRepeatable');
  // const slotId = get(selected, 'id');

  // if (slotId && !isRepeatable) {
  //   yield put(blockslotUpdate.actions.send({ ...payload, slotId }));
  //   yield cancel();
  // }

  yield put(blockslotInsert.actions.send(payload));
}

function* handleRecursion({ payload }) {
  const selectedSchedule = yield select(selectSchedulePopoverData);
  const { blockedSlot: scheduleFormData, ...restPayload } = payload;

  yield put(
    scheduleValidateActions.toggleRecursionModal({
      type: RECURSION_MODAL_TYPES.EDIT_BLOCK_SLOT,
      lastDay: isLastDayOfRepeat(selectedSchedule),
      opened: true,
    }),
  );

  const {
    payload: { option: recursionOption },
  } = yield take(SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);

  const formattedData = repeatScheduleAdapter(
    recursionOption,
    selectedSchedule,
    scheduleFormData,
  );

  if (!formattedData) {
    yield cancel();
  }

  yield call(insertOrUpdateBlockedSlot, {
    ...restPayload,
    blockedSlot: formattedData,
  });
}

function* handleBlockslotInsert(action) {
  const selectedSchedule = yield select(selectSchedulePopoverData);
  const isRepeatable = get(selectedSchedule, 'isRepeatable');

  if (isRepeatable) {
    yield call(handleRecursion, action);
    yield cancel();
  }

  yield call(insertOrUpdateBlockedSlot, action.payload);
}

export default function* blockslotInsertSaga() {
  yield takeLatest([blockslotInsert.consts.START], handleBlockslotInsert);
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/blockslot-insert-saga.js